export const TABLE_EMPTY_VALUE = '-';

const DATE_ONLY_REGEX = /^\d{4}-\d{2}-\d{2}$/;
const ISO_DATE_REGEX = /^\d{4}-\d{2}-\d{2}(?:[T\s].+)?$/;

export function formatTableCellValue(value: unknown): string {
  if (value === null || value === undefined) {
    return TABLE_EMPTY_VALUE;
  }

  if (typeof value === 'number') {
    return new Intl.NumberFormat('es-AR', {
      maximumFractionDigits: 2,
    }).format(value);
  }

  if (typeof value === 'boolean') {
    return value ? 'Sí' : 'No';
  }

  if (typeof value === 'string') {
    if (isDateString(value)) {
      return formatDateValue(value);
    }

    return value;
  }

  if (typeof value === 'object') {
    const record = value as Record<string, unknown>;

    const nombre = record.nombre;
    if (typeof nombre === 'string' && nombre.trim() !== '') {
      return nombre;
    }

    const codigo = record.codigo;
    if (typeof codigo === 'string' && codigo.trim() !== '') {
      return codigo;
    }

    const idValue = record.ID ?? record.id;
    if (typeof idValue === 'string' || typeof idValue === 'number') {
      return String(idValue);
    }

    try {
      return JSON.stringify(value);
    } catch {
      return String(value);
    }
  }

  return String(value);
}

function isDateString(value: string): boolean {
  if (!ISO_DATE_REGEX.test(value)) {
    return false;
  }

  return !Number.isNaN(Date.parse(value));
}

function formatDateValue(value: string): string {
  const formatter = new Intl.DateTimeFormat('es-AR');

  if (DATE_ONLY_REGEX.test(value)) {
    const date = new Date(`${value}T00:00:00Z`);
    return formatter.format(date);
  }

  return formatter.format(new Date(value));
}
